export const isCleanRedirect = (
    redirectURL: string,
    allowExternalUrls?: boolean,
): boolean => {
    const blacklist = ['javascript:', 'vbscript:'];

    if (!allowExternalUrls) {
        blacklist.push('//');
    }

    redirectURL = redirectURL.toLocaleLowerCase();
    return !blacklist.some((substring) => redirectURL.includes(substring));
};

export const encodeLoginRedirect = (redirectURL: string): string => {
    return encodeURIComponent(redirectURL);
};

export const decodeLoginRedirect = (redirectParam?: string | null): string => {
    if (!redirectParam) {
        return '/';
    }
    try {
        return decodeURIComponent(redirectParam);
    } catch {
        return '/';
    }
};

export const getLoginRedirectUrl = (loginRoute = '/login') => {
    if (typeof window === 'undefined') {
        return loginRoute;
    }
    const redirectValue = window.location.pathname + window.location.search;
    const redirect = encodeLoginRedirect(redirectValue);

    const searchParams = new URLSearchParams(window.location.search);
    const skipPostSignUp = searchParams.get('skipPostSignUp') === '1';

    const url = isCleanRedirect(redirectValue)
        ? `${loginRoute}${
              loginRoute.includes('?') ? '&' : '?'
          }redirect=${redirect}${skipPostSignUp ? '&skipPostSignUp=1' : ''}`
        : loginRoute;

    return url;
};
